import styles from "./ProductFilter.module.scss";
import { CustomContainer } from "../../atoms/DependencyHelper";
import React, { useState, useRef } from "react";
import SearchBoxAutoSuggest from "../../molecules/SearchBoxAutoSuggest/SearchBoxAutoSuggest";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import FilterNav from "../../molecules/filterNav/FilterNav";
import * as Analytics from "../../../services/analyticsUtag";

const ProductFilterMobile = ({
  closeRequired = true,
  className,
  hideFilter,
  resetClickHandler,
  onSearchTextSelect,
  handleError,
  isEligible,
  qualifyLabel,
  selectedFilter,
  brands,
}) => {
  const [disabled, setDisabled] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [acceptedSearchText, setAcceptedSearchText] = useState({});
  const searchBoxRef = useRef();
  const pageName = Analytics.getUtagData(["page_name"]).page_name;

  const handleSearchSelect = (val) => {
    let brandId = [];
    if (val.brandName) {
      brandId = brands.filter(
        (brand) =>
          brand.label.toLowerCase().indexOf(val.brandName.toLowerCase()) > -1
      );
    } else {
      val.brandName = "";
    }
    val["brandId"] = brandId.length > 0 ? brandId[0].value : "";
    setSearchText(val.label);
    setAcceptedSearchText(val);
    setDisabled(false);
  };

  const handleSearchTextChange = (val) => {
    if (val.trim().length < 3) {
      setDisabled(true);
    }
  };

  const ctaButtonClick = () => {
    if (searchText !== "" && searchText == acceptedSearchText.label) {
      onSearchTextSelect(true, acceptedSearchText);
      if (searchBoxRef.current && searchBoxRef.current.clearText) {
        searchBoxRef.current.clearText();
      }
    }
    hideFilter();
  };

  const resetSearch = () => {
    searchBoxRef.current.clearText();
    resetClickHandler();

    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: reset search filter`,
    });
  };

  return (
    <CustomContainer className={`${styles["navGutter"]} ${className}`}>
      <FilterNav
        headingName="Filter by product"
        backbtn={hideFilter}
        resetClickHandler={resetSearch}
        filterType="filter_by_product"
        selectedFilter={selectedFilter}
      />
      <CustomContainer className={`${styles["px-xxs-buffer"]}`}>
        <CustomContainer className={`${styles["search-container"]}`}>
          <SearchBoxAutoSuggest
            closeRequired={closeRequired}
            className={`${styles["search-box"]}`}
            handleSearchSelect={handleSearchSelect}
            handleSearchTextChange={handleSearchTextChange}
            ref={searchBoxRef}
            handleFilterError={handleError}
            showAffordabilityLabel={isEligible}
            qualifyLabel={qualifyLabel}
          />
          <CTAButton
            variant="solid red"
            className={`${styles["showResultsBtn"]} ${
              disabled ? styles["disabled"] : ""
            }`}
            handleClick={ctaButtonClick}
            disabled={disabled}
          >
            Show results
          </CTAButton>
        </CustomContainer>
      </CustomContainer>
    </CustomContainer>
  );
};

export default ProductFilterMobile;
